const ENV = process.env.REACT_APP_ENV || "development";

export const API_BASE_URL = (() => {
  switch (ENV) {
    case "tst":
      return "https://api.qa.textsentinel.roche.com/";
    case "prd":
      return "https://api.textsentinel.roche.com/";
    default:
      return "https://text-sentinel-api-dev.aws.cloud.roche.com/";
  }
})();

// Web Base URL configuration
export const SSO_URL = (() => {
  switch (ENV) {
    case "tst":
      return "https://wamqa.roche.com/idp/startSSO.ping?PartnerSpId=text_sentinel_tst";
    case "prd":
      return "https://wam.roche.com/idp/startSSO.ping?PartnerSpId=text_sentinel";
    default:
      return "https://wamqa.roche.com/idp/startSSO.ping?PartnerSpId=text_sentinel_dev";
  }
})();

export const SYSTEM_DASHBOARD_URL = (() => {
  switch (ENV) {
    case "tst":
      return "https://cloudwatch.amazonaws.com/dashboard.html?dashboard=TextSentinel&context=eyJSIjoidXMtZWFzdC0xIiwiRCI6ImN3LWRiLTMwNzk0NjY3NzI5NCIsIlUiOiJ1cy1lYXN0LTFfeE5aYXVBb0YxIiwiQyI6IjZsOWdtajZtYmhiNGQyM2FpcnZxaGtpaDRuIiwiSSI6InVzLWVhc3QtMTo2YTIyM2EyNC0xZjYwLTQ1MmYtYjVhZC1lYzhkNmMxYTE1NmIiLCJNIjoiUHVibGljIn0%3D";
    case "prd":
      return "https://cloudwatch.amazonaws.com/dashboard.html?dashboard=TextSentinel&context=eyJSIjoidXMtZWFzdC0xIiwiRCI6ImN3LWRiLTc3OTg0Njc5NDY3MCIsIlUiOiJ1cy1lYXN0LTFfZHR0UUlhOWxQIiwiQyI6IjI5MjM0aGowdGRoaHJmbXNvbzdndmhlcTdmIiwiSSI6InVzLWVhc3QtMTo1NzE4YzUwOC05NWQ3LTQ2Y2ItYmExZi1mMzY1MGEzNzZlYTgiLCJNIjoiUHVibGljIn0%3D";
    default:
      return "https://cloudwatch.amazonaws.com/dashboard.html?dashboard=TextSentinel&context=eyJSIjoidXMtZWFzdC0xIiwiRCI6ImN3LWRiLTE0MDAyMzQwMjY0MyIsIlUiOiJ1cy1lYXN0LTFfSWlJWDJHNWdzIiwiQyI6IjNnMTlzamZydXIxbHJudjY4czk1MnJoZTNoIiwiSSI6InVzLWVhc3QtMTowMzg4MmRjZi01YzFhLTRiMmUtYmY3ZC00ODZjMjcwNTQxMmMiLCJPIjoiYXJuOmF3czppYW06OjE0MDAyMzQwMjY0Mzpyb2xlL3NlcnZpY2Utcm9sZS9DV0RCU2hhcmluZy1QdWJsaWNSZWFkT25seUFjY2Vzcy1TTllJWVNRViIsIk0iOiJQdWJsaWMifQ%3D%3D";
  }
})();

export const ENVIRONMENT = ENV;
